import React from 'react';
import { OfficeId } from '../lib/types';
import { getOffice } from '../lib/config';

interface OfficeContextBannerProps {
  officeId?: OfficeId;
}

export default function OfficeContextBanner({ officeId }: OfficeContextBannerProps) {
  const office = officeId ? getOffice(officeId) : null;

  return (
    <div className="flex items-center gap-2">
      {office && (
        <>
          <div
            className="w-2.5 h-2.5 rounded-full shrink-0"
            style={{ backgroundColor: office.color }}
          />
          <span className="text-xs font-semibold text-gray-700">{office.name}</span>
        </>
      )}
      {!office && (
        <span className="text-xs font-semibold text-gray-700">All Offices</span>
      )}
    </div>
  );
}
